export enum Condition {
  RHEUMATOID_ARTHRITIS = "Rheumatoid Arthritis",
  ANKYLOSING_SPONDYLITIS = "Ankylosing Spondylitis",
  NON_RADIOGRAPHIC_AXIAL_SPONDYLOARTHRITIS = "Non-Radiographic Axial Spondyloarthritis",
  PSORIATIC_ARTHRITIS = "Psoriatic Arthritis",
  ULCERATIVE_COLITIS = "Ulcerative Colitis",
  CROHNS_DISEASE = "Crohn's Disease",
  PLAQUE_PSORIASIS = "Plaque Psoriasis",
  MIGRAINE = "Migraine",
  GOUT = "Gout",
  OBESITY = "Obesity",
  PANS = "PANS",
  PANDAS = "PANDAS",
  TYPE_2_DIABETES = "Type 2 Diabetes",
  ASTHMA = "Asthma",
  CSID = "CSID",
  HYPOPHOSPHATASIA = "Hypophosphatasia",
  ATOPIC_DERMATITIS = "Atopic Dermatitis (Eczema)",
  CHRONIC_RHINOSINUSITIS = "Chronic Rhinosinusitis with Nasal Polyps (CRSwNP)",
  EOSINOPHILIC_ESOPHAGITIS = "Eosinophilic Esophagitis (EoE)",
  PRURIGO_NODULARIS = "Prurigo Nodularis (PN)",
  COPD = "Chronic Obstructive Pulmonary Disease (COPD)",
  CHRONIC_SPONTANEOUS_URTICARIA = "Chronic Spontaneous Urticaria (CSU)",
  BULLOUS_PEMPHIGOID = "Bullous Pemphigoid (BP)",
  OBSTRUCTIVE_SLEEP_APNEA = "Obstructive Sleep Apnea (OSA)",
  MASH = "Metabolic dysfunction–associated steatohepatitis (MASH)",
  LIVER_CANCER = "Liver Cancer",
}

export function getReferrableConditions() {
  return Object.values(Condition).filter(
    (condition) => ![Condition.PANS, Condition.PANDAS].includes(condition),
  );
}

// Supported Medications for Appeals
//    DO NOT add to this list unless it is a new medication
//    we will be allowing users to create appeals for
export enum Medication {
  HUMIRA = "Humira",
  ABRILADA = "Abrilada",
  AMJEVITA = "Amjevita",
  HYRIMOZ = "Hyrimoz",
  HULIO = "Hulio",
  YUSIMRY = "Yusimry",
  YUFLYMA = "Yuflyma",
  IDACIO = "Idacio",
  HADLIMA = "Hadlima",
  CYLTEZO = "Cyltezo",
  CIMZIA = "Cimzia",
  ENBREL = "Enbrel",
  ERELZI = "Erelzi",
  ETICOVO = "Eticovo",
  SIMPONI = "Simponi",
  SIMPONI_ARIA = "Simponi Aria",
  REMICADE = "Remicade",
  INFLECTRA = "Inflectra",
  AVSOLA = "Avsola",
  RENFLEXIS = "Renflexis",
  ZYMFENTRA = "Zymfentra",
  IXIFI = "Ixifi",
  SIMLANDI = "Simlandi",
  RITUXAN = "Rituxan",
  TRUXIMA = "Truxima",
  RUXIENCE = "Ruxience",
  RIABNI = "Riabni",
  KINERET = "Kineret",
  KEVZARA = "Kevzara",
  ACTEMRA = "Actemra",
  ORENCIA = "Orencia",
  RINVOQ = "Rinvoq",
  XELJANZ = "Xeljanz",
  TALTZ = "Taltz",
  ILUMYA = "Ilumya",
  COSENTYX = "Cosentyx",
  TREMFYA = "Tremfya",
  SKYRIZI = "Skyrizi",
  STELARA = "Stelara",
  VYEPTI = "Vyepti",
  AIMOVIG = "Aimovig",
  AJOVY = "Ajovy",
  EMGALITY = "Emgality",
  NURTEC = "Nurtec",
  AMERGE = "Amerge",
  QULIPTA = "Qulipta",
  ZAVZPRET = "Zavzpret",
  AXERT = "Axert",
  ZOMIG = "Zomig",
  FROVA = "Frova",
  REYVOW = "Reyvow",
  IMITREX_NASAL = "Imitrex Nasal",
  IMITREX = "Imitrex",
  UBRELVY = "Ubrelvy",
  BOTOX = "Botox",
  ENTYVIO = "Entyvio",
  KRYSTEXXA = "Krystexxa",
  OTEZLA = "Otezla",
  SOTYKTU = "Sotyktu",
  OZEMPIC = "Ozempic",
  RYBELSUS = "Rybelsus",
  WEGOVY = "Wegovy",
  ZEPBOUND = "Zepbound",
  MOUNJARO = "Mounjaro",
  SINGULAIR = "Singulair",
  XOPENEX_HFA = "Xopenex HFA",
  ADVAIR_DISKUS = "Advair Diskus",
  ADVAIR_HFA = "Advair HFA",
  BREYNA = "Breyna",
  DULERA = "Dulera",
  SYMBICORT = "Symbicort",
  BREO_ELLIPTA = "Breo Ellipta",
  CINQAIR = "Cinqair",
  DUPIXENT = "Dupixent",
  FASENRA = "Fasenra",
  NUCALA = "Nucala",
  TEZSPIRE = "Tezspire",
  XOLAIR = "Xolair",
  SUCRAID = "Sucraid",
  STRENSIQ = "Strensiq",
  TRANSPLANTATION = "Transplantation",
}

export enum PansPandasMedication {
  GAMMAGARD_LIQUID_IVIG = "Gammagard Liquid (IVIG)",
  GAMMAGARD_LIQUID_SCIG = "Gammagard Liquid (SCIG)",
  GAMMAGARD_SD = "Gammagard S/D (IVIG)",
  GAMUNEX_C = "Gamunex-C (IVIG)",
  FLEBOGAMMA_DIF = "Flebogamma DIF (IVIG)",
  PRIVIGEN = "Privigen (IVIG)",
  OCTAGAM = "Octagam (IVIG)",
  BIVIGAM = "Bivigam (IVIG)",
  CARIMUNE_NF = "Carimune NF (IVIG)",
  PANGLOBULIN = "Panglobulin (IVIG)",
  NABI_HB = "Nabi-HB (IVIG)",
  INTRAVENOUS_IMMUNOGLOBULIN = "intravenous immunoglobulin (IVIG)",
  SUB_Q_IMMUNOGLOBULIN = "sub-q immunoglobulin (SCIG)",
}

export const medicationConditionPairs: Record<
  Condition,
  (Medication | PansPandasMedication)[]
> = {
  [Condition.RHEUMATOID_ARTHRITIS]: [
    Medication.HUMIRA,
    Medication.ABRILADA,
    Medication.AMJEVITA,
    Medication.HYRIMOZ,
    Medication.HULIO,
    Medication.YUSIMRY,
    Medication.YUFLYMA,
    Medication.IDACIO,
    Medication.HADLIMA,
    Medication.CYLTEZO,
    Medication.CIMZIA,
    Medication.ENBREL,
    Medication.ERELZI,
    Medication.ETICOVO,
    Medication.SIMPONI,
    Medication.SIMPONI_ARIA,
    Medication.REMICADE,
    Medication.INFLECTRA,
    Medication.AVSOLA,
    Medication.RENFLEXIS,
    Medication.IXIFI,
    Medication.SIMLANDI,
    Medication.RITUXAN,
    Medication.TRUXIMA,
    Medication.RUXIENCE,
    Medication.RIABNI,
    Medication.KINERET,
    Medication.KEVZARA,
    Medication.ACTEMRA,
    Medication.ORENCIA,
    Medication.RINVOQ,
    Medication.XELJANZ,
  ],
  [Condition.ANKYLOSING_SPONDYLITIS]: [
    Medication.HUMIRA,
    Medication.ABRILADA,
    Medication.AMJEVITA,
    Medication.HYRIMOZ,
    Medication.HULIO,
    Medication.YUSIMRY,
    Medication.YUFLYMA,
    Medication.IDACIO,
    Medication.HADLIMA,
    Medication.CYLTEZO,
    Medication.CIMZIA,
    Medication.ENBREL,
    Medication.ERELZI,
    Medication.ETICOVO,
    Medication.SIMPONI,
    Medication.SIMPONI_ARIA,
    Medication.REMICADE,
    Medication.INFLECTRA,
    Medication.AVSOLA,
    Medication.RENFLEXIS,
    Medication.IXIFI,
    Medication.SIMLANDI,
    Medication.TALTZ,
    Medication.COSENTYX,
    Medication.RINVOQ,
  ],
  [Condition.NON_RADIOGRAPHIC_AXIAL_SPONDYLOARTHRITIS]: [
    Medication.CIMZIA,
    Medication.TALTZ,
    Medication.COSENTYX,
    Medication.RINVOQ,
  ],
  [Condition.PSORIATIC_ARTHRITIS]: [
    Medication.HUMIRA,
    Medication.ABRILADA,
    Medication.AMJEVITA,
    Medication.HYRIMOZ,
    Medication.HULIO,
    Medication.YUSIMRY,
    Medication.YUFLYMA,
    Medication.IDACIO,
    Medication.HADLIMA,
    Medication.CYLTEZO,
    Medication.CIMZIA,
    Medication.ENBREL,
    Medication.ERELZI,
    Medication.ETICOVO,
    Medication.SIMPONI,
    Medication.SIMPONI_ARIA,
    Medication.REMICADE,
    Medication.INFLECTRA,
    Medication.AVSOLA,
    Medication.RENFLEXIS,
    Medication.IXIFI,
    Medication.SIMLANDI,
    Medication.TALTZ,
    Medication.COSENTYX,
    Medication.TREMFYA,
    Medication.SKYRIZI,
    Medication.STELARA,
    Medication.ORENCIA,
    Medication.XELJANZ,
    Medication.RINVOQ,
    Medication.OTEZLA,
  ],
  [Condition.ULCERATIVE_COLITIS]: [
    Medication.HUMIRA,
    Medication.ABRILADA,
    Medication.AMJEVITA,
    Medication.HYRIMOZ,
    Medication.HULIO,
    Medication.YUSIMRY,
    Medication.YUFLYMA,
    Medication.IDACIO,
    Medication.HADLIMA,
    Medication.CYLTEZO,
    Medication.SIMPONI,
    Medication.REMICADE,
    Medication.INFLECTRA,
    Medication.ENTYVIO,
    Medication.AVSOLA,
    Medication.RENFLEXIS,
    Medication.ZYMFENTRA,
    Medication.IXIFI,
    Medication.SIMLANDI,
    Medication.RINVOQ,
    Medication.XELJANZ,
    Medication.STELARA,
  ],
  [Condition.CROHNS_DISEASE]: [
    Medication.HUMIRA,
    Medication.ABRILADA,
    Medication.AMJEVITA,
    Medication.HYRIMOZ,
    Medication.HULIO,
    Medication.YUSIMRY,
    Medication.YUFLYMA,
    Medication.IDACIO,
    Medication.HADLIMA,
    Medication.CYLTEZO,
    Medication.ENTYVIO,
    Medication.CIMZIA,
    Medication.REMICADE,
    Medication.INFLECTRA,
    Medication.AVSOLA,
    Medication.RENFLEXIS,
    Medication.ZYMFENTRA,
    Medication.IXIFI,
    Medication.SIMLANDI,
    Medication.STELARA,
    Medication.RINVOQ,
  ],
  [Condition.PLAQUE_PSORIASIS]: [
    Medication.HUMIRA,
    Medication.ABRILADA,
    Medication.AMJEVITA,
    Medication.HYRIMOZ,
    Medication.HULIO,
    Medication.YUSIMRY,
    Medication.YUFLYMA,
    Medication.IDACIO,
    Medication.HADLIMA,
    Medication.CYLTEZO,
    Medication.CIMZIA,
    Medication.ENBREL,
    Medication.ERELZI,
    Medication.ETICOVO,
    Medication.TREMFYA,
    Medication.TALTZ,
    Medication.ILUMYA,
    Medication.COSENTYX,
    Medication.SKYRIZI,
    Medication.STELARA,
    Medication.OTEZLA,
    Medication.SOTYKTU,
  ],
  [Condition.MIGRAINE]: [
    Medication.VYEPTI,
    Medication.AIMOVIG,
    Medication.AJOVY,
    Medication.EMGALITY,
    Medication.NURTEC,
    Medication.AMERGE,
    Medication.QULIPTA,
    Medication.ZAVZPRET,
    Medication.AXERT,
    Medication.ZOMIG,
    Medication.FROVA,
    Medication.REYVOW,
    Medication.IMITREX_NASAL,
    Medication.IMITREX,
    Medication.UBRELVY,
    Medication.BOTOX,
  ],
  [Condition.GOUT]: [Medication.KRYSTEXXA],
  [Condition.PANS]: [
    PansPandasMedication.GAMMAGARD_LIQUID_IVIG,
    PansPandasMedication.GAMMAGARD_LIQUID_SCIG,
    PansPandasMedication.GAMMAGARD_SD,
    PansPandasMedication.GAMUNEX_C,
    PansPandasMedication.FLEBOGAMMA_DIF,
    PansPandasMedication.PRIVIGEN,
    PansPandasMedication.OCTAGAM,
    PansPandasMedication.BIVIGAM,
    PansPandasMedication.CARIMUNE_NF,
    PansPandasMedication.PANGLOBULIN,
    PansPandasMedication.NABI_HB,
    PansPandasMedication.INTRAVENOUS_IMMUNOGLOBULIN,
    PansPandasMedication.SUB_Q_IMMUNOGLOBULIN,
  ],
  [Condition.PANDAS]: [
    PansPandasMedication.GAMMAGARD_LIQUID_IVIG,
    PansPandasMedication.GAMMAGARD_LIQUID_SCIG,
    PansPandasMedication.GAMMAGARD_SD,
    PansPandasMedication.GAMUNEX_C,
    PansPandasMedication.FLEBOGAMMA_DIF,
    PansPandasMedication.PRIVIGEN,
    PansPandasMedication.OCTAGAM,
    PansPandasMedication.BIVIGAM,
    PansPandasMedication.CARIMUNE_NF,
    PansPandasMedication.PANGLOBULIN,
    PansPandasMedication.NABI_HB,
    PansPandasMedication.INTRAVENOUS_IMMUNOGLOBULIN,
    PansPandasMedication.SUB_Q_IMMUNOGLOBULIN,
  ],
  [Condition.OBESITY]: [Medication.WEGOVY, Medication.ZEPBOUND],
  [Condition.OBSTRUCTIVE_SLEEP_APNEA]: [Medication.ZEPBOUND],
  [Condition.MASH]: [Medication.WEGOVY],
  [Condition.TYPE_2_DIABETES]: [
    Medication.OZEMPIC,
    Medication.RYBELSUS,
    Medication.MOUNJARO,
  ],
  [Condition.ASTHMA]: [
    Medication.SINGULAIR,
    Medication.XOPENEX_HFA,
    Medication.ADVAIR_DISKUS,
    Medication.ADVAIR_HFA,
    Medication.BREYNA,
    Medication.DULERA,
    Medication.SYMBICORT,
    Medication.BREO_ELLIPTA,
    Medication.CINQAIR,
    Medication.DUPIXENT,
    Medication.FASENRA,
    Medication.NUCALA,
    Medication.TEZSPIRE,
    Medication.XOLAIR,
  ],
  [Condition.CSID]: [Medication.SUCRAID],
  [Condition.HYPOPHOSPHATASIA]: [Medication.STRENSIQ],
  [Condition.ATOPIC_DERMATITIS]: [Medication.DUPIXENT],
  [Condition.CHRONIC_RHINOSINUSITIS]: [Medication.DUPIXENT],
  [Condition.EOSINOPHILIC_ESOPHAGITIS]: [Medication.DUPIXENT],
  [Condition.PRURIGO_NODULARIS]: [Medication.DUPIXENT],
  [Condition.COPD]: [Medication.DUPIXENT],
  [Condition.CHRONIC_SPONTANEOUS_URTICARIA]: [Medication.DUPIXENT],
  [Condition.BULLOUS_PEMPHIGOID]: [Medication.DUPIXENT],
  [Condition.LIVER_CANCER]: [Medication.TRANSPLANTATION],
};

export const getConditionsTreatedByMedication = (
  medication: Medication | PansPandasMedication,
) => {
  const conditionsTreatedByMedication = Object.entries(medicationConditionPairs)
    .filter(([, medications]) => medications.includes(medication))
    .map(([condition]) => condition);

  return conditionsTreatedByMedication;
};
const caseInsensitiveSort = (a: string, b: string) =>
  a.localeCompare(b, undefined, { sensitivity: "base" });

export const getMedications = (condition?: Condition) => {
  const medications = condition
    ? medicationConditionPairs[condition]
    : Object.values(Medication);

  return medications.sort(caseInsensitiveSort);
};

export const getConditions = (conditionalConditons?: {
  [key in Condition]?: boolean;
}) => {
  const conditions = new Set(Object.values(Condition));

  if (conditionalConditons) {
    Object.entries(conditionalConditons).forEach(([condition, isIncluded]) => {
      if (!isIncluded) {
        conditions.delete(condition as Condition);
      }
    });
  }

  return Array.from(conditions).sort(caseInsensitiveSort);
};

type GetMedicationsForReferralOptions = {
  conditions?: {
    [key in Condition]?: boolean;
  };
  medications?: {
    [key in Medication | PansPandasMedication]?: boolean;
  };
};

const mapOptionsObjectToIndividualOptions = (options?: {
  [key: string]: boolean | undefined;
}) =>
  !options
    ? []
    : Object.entries(options)
        .filter(([, isIncluded]) => !isIncluded)
        .map(([option]) => option);

export const getMedicationsForReferral = ({
  conditions,
  medications,
}: GetMedicationsForReferralOptions = {}) => {
  const conditionsToFilterOut = mapOptionsObjectToIndividualOptions(conditions);
  const medicationsToFilterOut =
    mapOptionsObjectToIndividualOptions(medications);

  return Array.from(
    new Set(
      Object.entries(medicationConditionPairs)
        .filter(([condition]) => !conditionsToFilterOut.includes(condition))
        .flatMap(([, medicationsForCondition]) => medicationsForCondition)
        .filter((medication) => !medicationsToFilterOut.includes(medication)),
    ),
  ).sort(caseInsensitiveSort);
};

export const isGlp1Condition = (
  condition: unknown,
): condition is Condition.OBESITY | Condition.TYPE_2_DIABETES =>
  typeof condition === "string" &&
  ([Condition.OBESITY, Condition.TYPE_2_DIABETES] as string[]).includes(
    condition,
  );

export const isHypophosphatasia = (
  condition: unknown,
): condition is Condition.HYPOPHOSPHATASIA =>
  typeof condition === "string" && condition === Condition.HYPOPHOSPHATASIA;

export function requiresWhoIsAppealFor(
  condition: string | null,
  medication: string | null,
): boolean {
  if (condition === Condition.CSID && medication === Medication.SUCRAID) {
    return true;
  }

  if (medication === Medication.DUPIXENT) {
    return [
      Condition.ASTHMA,
      Condition.ATOPIC_DERMATITIS,
      Condition.CHRONIC_RHINOSINUSITIS,
      Condition.EOSINOPHILIC_ESOPHAGITIS,
    ].includes(condition as Condition);
  }

  return false;
}
